import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function userReducer(state = initialState.user, action) {
  switch (action.type) {
    case types.SET_USER_MENU:
      return { ...state, menu: action.menu };
    case types.SET_USER_INFO:
      return { ...state, info: action.info };
    case types.SET_USER_PROFILE:
      return { ...state, info: { ...state.info, profile: action.profile } };
    default:
      return state;
  }
}
